<template>
    <div class="admin">
        <form style="margin-bottom:10px;">
            <a-row type="flex" justify="start">
                <a-col :span="7">
                    <a-row :gutter="10">
                        <a-col :span="17">
                            <a-input v-model="keyword" placeholder="请输入关键词" />
                        </a-col>
                        <a-col :span="3">
                            <a-button type="primary" @click="get_data()">搜索</a-button>
                        </a-col>
                    </a-row>
                </a-col>
                <a-col :span="2">
                    <a-button type="primary" @click="add" v-if="$Func.check_rank('admin_add')">添加管理员</a-button>
                </a-col>
            </a-row>
        </form>
        <a-table :columns="columns" :data-source="tableData" @change="change_filter" :loading="loading" :pagination="page" bordered>
            <template slot="operation" slot-scope="text, record">
                <a @click="()=>{update_data(record)}" v-if="$Func.check_rank('admin_edit')">编辑</a>
                <a-divider type="vertical" />
                <a @click="()=>{delete_data(record)}" v-if="$Func.check_rank('admin_del')">删除</a>
            </template>
        </a-table>
        <a-drawer
          title="增加管理员"
          :width="720"
          :maskStyle="{backgroundColor: '#00000010'}"
          :visible="add_model"
          :body-style="{ paddingBottom: '80px' }"
          @close="add_model=false"
          v-if="$Func.check_rank('admin_add')"
        >
            <a-form-model :model="admin_add" :rules="add_rules" layout="vertical" @submit="add_data" ref="add_form">
                <a-form-model-item ref="group" prop="group" label="分组">
                    <a-select default-value="1" style="width: 120px" v-model="admin_add.group">
                        <a-select-option v-for="val in group_list" :key="val.id" :value="val.id">{{val.title}}</a-select-option>
                    </a-select>
                </a-form-model-item>
                <a-form-model-item ref="username" prop="username" label="账号">
                    <a-input
                        v-model="admin_add.username"
                        placeholder="请输入账号"
                    />
                </a-form-model-item>
                <a-form-model-item ref="password" prop="password" label="密码">
                    <a-input-password
                        v-model="admin_add.password"
                        placeholder="请输入密码"
                    />
                </a-form-model-item>
                <a-form-model-item ref="truename" prop="truename" label="姓名">
                    <a-input
                        v-model="admin_add.truename"
                        placeholder="请输入姓名"
                    />
                </a-form-model-item>
                <a-form-model-item ref="check" prop="check" label="审核">
                    <a-radio-group default-value="1" v-model="admin_add.check" button-style="solid">
                        <a-radio-button :value="1">审核通过</a-radio-button>
                        <a-radio-button :value="0">审核拒绝</a-radio-button>
                    </a-radio-group>
                </a-form-model-item>
                <a-form-model-item ref="status" prop="status" label="状态">
                    <a-radio-group default-value="1" v-model="admin_add.status" button-style="solid">
                        <a-radio-button :value="1">正常</a-radio-button>
                        <a-radio-button :value="0">停用</a-radio-button>
                    </a-radio-group>
                </a-form-model-item>
                <div :style="{
                    position: 'absolute',
                    right: 0,
                    bottom: 0,
                    width: '100%',
                    borderTop: '1px solid #e9e9e9',
                    padding: '10px 16px',
                    background: '#fff',
                    textAlign: 'right',
                    zIndex: 1,
                }">
                    <a-button :style="{ marginRight: '8px' }" @click="add_model=false">
                        取消
                    </a-button>
                    <a-button type="primary" html-type="submit">
                        确定
                    </a-button>
                </div>
            </a-form-model>
        </a-drawer>
        <a-drawer
          title="修改管理员"
          :width="720"
          :maskStyle="{backgroundColor: '#00000010'}"
          :visible="update_model"
          :body-style="{ paddingBottom: '80px' }"
          @close="update_model=false"
          v-if="$Func.check_rank('admin_edit')"
        >
            <a-form-model :model="admin_update" :rules="update_rules" layout="vertical" @submit="save_data" ref="update_form">
                <a-form-model-item ref="group" prop="group" label="分组">
                    <a-select default-value="1" style="width: 120px" v-model="admin_update.group">
                        <a-select-option v-for="val in group_list" :key="val.id" :value="val.id">{{val.title}}</a-select-option>
                    </a-select>
                </a-form-model-item>
                <a-form-model-item label="账号">
                    <a-input
                        v-model="admin_update.username"
                        placeholder="请输入账号"
                    />
                </a-form-model-item>
                <a-form-model-item label="密码">
                    <a-input-password
                        v-model="admin_update.password"
                        placeholder="如果不更改密码请不要填写"
                    />
                </a-form-model-item>
                <a-form-model-item ref="truename" prop="truename" label="姓名">
                    <a-input
                        v-model="admin_update.truename"
                        placeholder="请输入姓名"
                    />
                </a-form-model-item>
                <a-form-model-item ref="check" prop="check" label="审核">
                    <a-radio-group default-value="1" v-model="admin_update.check" button-style="solid">
                        <a-radio-button :value="1">审核通过</a-radio-button>
                        <a-radio-button :value="0">审核拒绝</a-radio-button>
                    </a-radio-group>
                </a-form-model-item>
                <a-form-model-item ref="status" prop="status" label="状态">
                    <a-radio-group default-value="1" v-model="admin_update.status" button-style="solid">
                        <a-radio-button :value="1">正常</a-radio-button>
                        <a-radio-button :value="0">停用</a-radio-button>
                    </a-radio-group>
                </a-form-model-item>
                <div :style="{
                    position: 'absolute',
                    right: 0,
                    bottom: 0,
                    width: '100%',
                    borderTop: '1px solid #e9e9e9',
                    padding: '10px 16px',
                    background: '#fff',
                    textAlign: 'right',
                    zIndex: 1,
                }">
                    <a-button :style="{ marginRight: '8px' }" @click="update_model=false">
                        取消
                    </a-button>
                    <a-button type="primary" html-type="submit">
                        确定
                    </a-button>
                </div>
            </a-form-model>
        </a-drawer>
    </div>
</template>

<script>
    import Func from '../../common/func'
    const columns = [
        {
            title: '#',
            dataIndex: 'id',
            key: 'id',
            width: 80,
        },
        {
            title: '分组',
            dataIndex: 'admin_group_title',
            key: 'admin_group_title',
            width: 120,
        },
        {
            title: '账号',
            dataIndex: 'username',
            key: 'username',
            width: 120,
        },
        {
            title: '姓名',
            dataIndex: 'truename',
            key: 'truename',
            width: 120,
        },
        {
            title: '审核',
            dataIndex: 'check_str',
            key: 'check_str',
            width: 80,
        },
        {
            title: '状态',
            dataIndex: 'status_str',
            key: 'status_str',
            width: 80,
        },
        {
            title: '创建时间',
            dataIndex: 'created',
            key: 'created',
            width: 180,
        },
        {
            title: '修改时间',
            dataIndex: 'modified',
            key: 'modified',
            width: 180,
        },
        {
            title: '操作',
            dataIndex: 'id',
            width: 180,
            key:'operation',
            scopedSlots: { customRender: 'operation' },
        },
    ];
    export default {
        name: 'Admin',
        data(){
            return {
                columns,
                form: this.$form.createForm(this),
                keyword:'',
                tableData:[],
                loading:false,
                add_model:false,
                update_model:false,
                group_list:[],
                admin_add:{
                    group:1,
                    password:'',
                    username:'',
                    truename:'',
                    check:1,
                    status:1
                },
                admin_update:{
                    id:0,
                    group:1,
                    password:'',
                    username:'',
                    truename:'',
                    check:1,
                    status:1
                },
                add_rules: {
                    username:[{ required: true, message: '请输入账号', trigger: 'blur' }],
                    password:[{ required: true, message: '请输入密码', trigger: 'blur' }],
                },
                update_rules: {
                    username:[{ required: true, message: '请输入账号', trigger: 'blur' }],
                },
                page:{
                    current:1,
                    total:0,
                    pageSize:10
                }
            }
        },
        mounted() {
            this.get_data();
            this.get_group();
        },
        methods: {
            change_filter(pagination){
                this.get_data(pagination.current);
            },
            get_data(page,tip) {
                var keyword = this.keyword;
                if (!page) {
                    page = this.page.current||1;
                }

                if(!tip){
                    this.loading = true
                }

                Func.url_get({
                    action:'admin',
                    keyword: keyword,
                    page: page
                },(res) => {
                    this.tableData = res.info.list;
                    var pagination={
                        pageSize:10,
                        total:res.info.foot.total,
                        current:parseInt(res.info.foot.current)
                    }
                    this.page=pagination;
                    this.loading = false
                });
            },

            add(){
                this.admin_add={
                    group:1,
                    password:'',
                    username:'',
                    truename:'',
                    check:1,
                    status:1
                };
                this.add_model=true;
            },

            add_data(e){
                e.preventDefault();
                this.$refs.add_form.validate(valid => {
                    if (valid) {
                        Func.url_post({
                            action:'admin.add_data',
                            ...this.admin_add
                        },(res) => {
                            if(res.error===0){
                                this.$message.success(res.info);
                                this.add_model=false;
                                this.get_data(1,true);
                            }else{
                                this.$message.error(res.info);
                            }
                        });
                    }else{
                        return false;
                    }
                });
            },

            save_data(e){
                e.preventDefault();
                this.$refs.update_form.validate(valid => {
                    if (valid) {
                        Func.url_post({
                            action:'admin.save_data',
                            ...this.admin_update
                        },(res) => {
                            if(res.error===0){
                                this.$message.success(res.info);
                                this.update_model=false;
                                this.get_data(1,true);
                            }else{
                                this.$message.error(res.info);
                            }
                        });
                    }else{
                        return false;
                    }
                });
            },
            update_data(res){
                const item=JSON.parse(JSON.stringify(res));
                item.password='';
                this.admin_update=item;
                this.update_model=true;
            },

            delete_data(item){
                if(confirm('确定要删除吗')==true){
                    Func.url_get({
                        action:'admin.del_data',
                        id:item.id
                    },(res) => {
                        if(res.error===0){
                            this.$message.success(res.info);
                            this.get_data(1,true);
                        }else{
                            this.$message.error(res.info);
                        }
                    });
                }
            },

            get_group() {
                Func.url_get({
                    action:'admingroup.get_all'
                },(res) => {
                    this.group_list = res.info;
                });
            },

            goto_url(url,id){
                this.$router.push({
                    path:'/admin/'+url,
                    params:{
                        id:id
                    }
                });
            }
        }
    }
</script>
<style lang="scss">
</style>